<app-breadcrumb [title]="'Consultar'" [items]="['Extractos']" [active_item]="'Consultar'">
</app-breadcrumb>
<div class="container-fluid">
<div class="card">
  <div class="card-header d-flex align-items-center bg-primary text-white">
    <i class="icofont icofont-verification-check me-2"></i>
    <h5 class="mb-0"><strong>CONSULTAR EXTRACTO</strong></h5>
  </div>

  <div class="card-body">
    <form [formGroup]="formPlanilla">
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label" for="objeto"><strong>Objeto del contrato:</strong></label>
          <ng-select #inputObjeto id="objeto" [items]="objetos" bindLabel="descripcion" bindValue="id"
            placeholder="Selecciona una opción" formControlName="objeto" class="js-example-placeholder-multiple">
          </ng-select>
        </div>
        <div class="col-md-3">
          <label class="form-label" for="vehiculos"><strong>Placa:</strong></label>
          <ng-select id="vehiculos" [items]="vehiculos" bindLabel="placa" bindValue="placa"
            placeholder="Selecciona una placa" formControlName="placa" class="js-example-placeholder-multiple">
          </ng-select>
        </div>
        <div class="col-md-3">
          <label class="form-label" for="finicial"><strong>Fecha inicial:</strong></label>
          <div class="input-group input-group-sm">
            <input id="finicial" type="date" formControlName="finicial" class="form-control form-control-lg fs-14"
              (change)="actualizarMinFechaFinal()" [max]="hoy" onkeydown="return false;" />
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label" for="ffinal"><strong>Fecha final:</strong></label>
          <div class="input-group input-group-sm">
            <input id="ffinal" type="date" formControlName="ffinal" class="form-control form-control-lg fs-14"
              [min]="minFechaFinal" [max]="hoy" onkeydown="return false;" />
          </div>
        </div>
      </div>
    </form>
    <div class="card card-absolute border border-primary rounded my-5">
      <div class="card-header bg-primary">
        <h5 class="text-white"><strong>FILTROS RÁPIDOS</strong></h5>
      </div>
      <div class="card-body">
        <div class="row g-3 mb-3">
          <div class="col-md-2">
            <button type="button" class="btn btn-outline-primary btn-sm w-100" (click)="seleccionarRango('dia')"><strong>AYER</strong></button>
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-outline-primary btn-sm w-100"
              (click)="seleccionarRango('semana')"><strong>ÚLTIMA SEMANA</strong></button>
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-outline-primary btn-sm w-100"
              (click)="seleccionarRango('mes')"><strong>MES</strong></button>
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-outline-primary btn-sm w-100"
              (click)="seleccionarRango('trimestre')"><strong>TRIMESTRE</strong></button>
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-outline-primary btn-sm w-100"
              (click)="seleccionarRango('semestre')"><strong>SEMESTRE</strong></button>
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-outline-primary btn-sm w-100"
              (click)="seleccionarRango('anio')"><strong>AÑO</strong></button>
          </div>

        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center gap-3 mt-3">
      <button class="btn btn-primary" (click)="consultarFuec()" type="submit">
        CONSULTAR
      </button>
    </div>
  </div>
</div>



<div class="card" *ngIf="mostrarTabla">
  <div class="card-header bg-primary">
    <h5 class="text-uppercase text-white"><strong>LISTADO EXTRACTOS</strong></h5>
  </div>

  <div class="card-body custom-datatable noscroll">
    <div class="row mb-12">
      <div class="col-md-3 ms-auto"> 
        <div class="input-group">
          <input type="text" class="form-control" placeholder="Buscar....." [(ngModel)]="searchText"
            (input)="filterData()" />
          <span class="input-group-text">
            <i class="fa fa-search"></i> <!-- Icono de búsqueda -->
          </span>
        </div>
      </div>
    </div>

    <div class="custom-datatable table-responsive my-4">
      <table class="table table-hover table-bordered" id="tblConsulta">
        <thead class="bg-primary">
          <tr>
            <th class="text-center"><strong>FUEC</strong></th>
            <th class="text-center"><strong>INTERNO</strong></th>
            <th class="text-center"><strong>PLACA</strong></th>
            <th class="text-center"><strong>CONTRATO</strong></th>
            <th class="text-center"><strong>CONTRATISTA</strong></th>
            <th class="text-center"><strong>NIT CONTRATISTA</strong></th>
            <th class="text-center"><strong>OBJETO DE CONTRATO</strong></th>
            <th class="text-center"><strong>RUTA</strong></th>
            <th class="text-center"><strong>FECHA INICIAL</strong></th>
            <th class="text-center"><strong>FECHA FINAL</strong></th>
            <th class="text-center"><strong>CONDUCTOR #1</strong></th>
            <th class="text-center"><strong>CONDUCTOR #2</strong></th>
            <th class="text-center"><strong>CONDUCTOR #3</strong></th>
            <th class="text-center"><strong>REGISTRO</strong></th>
            <th class="text-center"></th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let planilla of filteredTableItems | paginate: { itemsPerPage: pageSize1, currentPage: page1 }">

            <td class="text-center">{{ planilla.nfuec }}{{ padNumero(planilla.contrato) }}{{ padNumero(planilla.idfuec) }} </td>
            <td class="text-center">{{ planilla.interno }}</td>
            <td class="text-center">{{ planilla.placa }}</td>
            <td class="text-center">{{ padNumero(planilla.contrato) }}</td>
            <td class="text-center">{{ planilla.nitc }}</td>
            <td class="text-center">{{ planilla.empresa }}</td>
            <td class="text-center">{{ planilla.descripcionObjeto.descripcion }}</td>
            <td class="text-center">{{ planilla.ruta }}</td>
            <td class="text-center">{{ planilla.finicial | date:'dd/MM/yyyy' }}</td>
            <td class="text-center">{{ planilla.ffinal | date:'dd/MM/yyyy' }}</td>
            <td class="text-center text-uppercase">
              {{ planilla.conductor }}
              
            </td>
           <td class="text-center text-uppercase">
              {{ planilla.conductor1 }}
            </td>
            <td class="text-center text-uppercase">
              {{ planilla.conductor2 }}
            </td>
            <td class="text-center">{{ planilla.registro | date:'dd/MM/yyyy' }} - {{ planilla.hora }}
            </td>
             <td class="text-center">
            <div class="action text-center">
                  <ul class="list-inline mb-0">
                    <li class="list-inline-item ">                                            
                      <a href="javascript:void(0)" (click)="imprimirFuec(planilla.idfuec)" ngbTooltip="Imprimir">
                        <i class="icon-printer"></i>
                      </a>
                    </li>
                   
                  </ul>
                </div>
            </td>

            <!-- Buscar tarjeta correspondiente -->
          </tr>
          <tr *ngIf="filteredTableItems.length === 0">
            <td class="text-center text-warning" colspan="16">
              {{ mensajeBusqueda || 'No se encontraron resultados con los filtros proporcionados.' }}
            </td>
          </tr>
        </tbody>
      </table>

    </div>
    <div class="row g-3 align-items-center mt-4">
  
  <!-- Selector de registros -->
  <div class="col-12 col-md-auto text-center text-md-start">
    <div class="d-flex justify-content-center justify-content-md-start align-items-center">
      <label for="pageSize1" class="me-2">Mostrar:</label>
      <select id="pageSize1" class="form-select w-auto"
              [(ngModel)]="pageSize1"
              (change)="page1 = 1">
        <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">
          {{ size1 }}
        </option>
      </select>
      <span class="ms-2">registros por página</span>
    </div>
  </div>

  <!-- Total registros -->
  <div class="col-12 col-md text-center">
    <span class="badge bg-primary">
      <b>Total registros: {{ filteredTableItems.length || 0 }}</b>
    </span>
  </div>

  <!-- Paginador -->
  <div class="col-12 col-md-auto text-center text-md-end">
    <pagination-controls
      (pageChange)="page1 = $event"
      [maxSize]="5"
      [directionLinks]="true"
      [autoHide]="true"
      previousLabel="Anterior"
      nextLabel="Siguiente">
    </pagination-controls>
  </div>

</div>

    <div class="card-body">
      <div class="btn-showcase text-center">
        <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
          (click)="exportarExcel('tblConsulta', 'Listado_Consulta')">
          <i class="icofont icofont-file-excel"></i> EXCEL
        </button>

        <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF" (click)="
            exportToPDF(
              'tblConsulta',
              'Listado_Consulta',
              'Listado de Consulta'
            )
          ">
          <i class="icofont icofont-file-pdf"></i> PDF
        </button>

      </div>
    </div>
  </div>
</div>
</div>


